export const Aging = {
  NB: 1, // T+1
  RENEW: 3 // T+3
}
